<template>
	<NuxtLink
			class="dashboard-widget-button"
			:to="to"
	>
		<span class="text" v-text="text"></span>
		<strong class="number" :class="colorForNumber" v-text="number"></strong>
		<span class="icon"><IconSvg icon="chevron-right" /></span>
	</NuxtLink>
</template>
<script lang="ts" setup>
	import type {PropType} from 'vue';
	import type {RouteLocationRaw} from 'vue-router';
	import IconSvg from '~/components/generic/IconSvg.vue';

	defineProps({
		to: {
			type: [String, Object] as PropType<RouteLocationRaw>,
			required: true
		},
		text: {
			type: String,
			required: true
		},
		number: {
			type: [String, Number],
			required: true
		},
		colorForNumber: {
			type: String as PropType<'neutral' | 'success' | 'warning' | 'danger'>,
			default: 'neutral'
		}
	});
</script>

<style scoped>
	.dashboard-widget-button {
		color: inherit;
		text-decoration: none;
		display: grid;
		grid-template-columns: 1fr 60px 60px;
		align-items: center;
		font-size: var(--font-size-p-2);
		min-height: 60px;
		border-radius: 5px;
		border: 1px solid var(--color-grey-100);

		&:focus,
		&:hover {
			border-color: var(--color-grey-500);
		}
	}

	.text {
		padding: .75em;
		align-self: center;
	}

	.number {
		font-size: 1.25em;
		font-weight: bold;
		background: var(--background-color-main);
		display: grid;
		align-items: center;
		justify-content: center;
		align-self: stretch;
	}

	.icon {
		display: grid;
		align-content: center;
		justify-content: center;
	}

	.warning {
		color: var(--color-warning);
	}

	.danger {
		color: var(--color-error);
	}

	.success {
		color: var(--color-success)
	}
</style>
